import merge from 'lodash/merge';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { THEMES } from '../constants';
import { lightShadows, darkShadows } from './shadows';
import { radioClasses } from '@mui/material';

const baseOptions = {
  direction: 'ltr',
  components: {
    MuiAvatar: { styleOverrides: { fallback: { height: '75%', width: '75%' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
    MuiCssBaseline: {
      styleOverrides: {
        '*': { boxSizing: 'border-box' },
        html: { MozOsxFontSmoothing: 'grayscale', WebkitFontSmoothing: 'antialiased', height: '100%', width: '100%' },
        body: { height: '100%' },
        '#root': { height: '100%' },
        '#nprogress .bar': { zIndex: '2000 !important' },
      },
    },
    MuiCardHeader: { defaultProps: { titleTypographyProps: { variant: 'h6' } } },
    MuiLinearProgress: { styleOverrides: { root: { borderRadius: 3, overflow: 'hidden' } } },
    MuiListItemIcon: { styleOverrides: { root: { minWidth: 'auto', marginRight: '16px' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiModal: { styleOverrides: { root: { zIndex: 1300 } } },
  },
  typography: {
    // htmlFontSize: '16', // change original 16
    // fontSize: '14', // change original 14
    button: { fontWeight: 600 },
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    h1: {
      fontWeight: 600,
      fontSize: '3.5rem', // change era '3.5rem'
    },
    h2: {
      fontWeight: 600,
      fontSize: '3rem', // change era '3rem'
    },
    h3: {
      fontWeight: 600,
      fontSize: '2.25rem', // change era '2.25rem'
    },
    h4: {
      fontWeight: 600,
      fontSize: '2rem', // change era '2rem'
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem', // change era '1.5rem'
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.125rem', // change era '1.125rem'
    },
    overline: { fontWeight: 600 },
    caption: {
      fontSize: '0.9rem', // change era '0.9rem'
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '1rem', // change no estaba
    },
    subtitle2: { fontSize: '0.9rem' },
    body1: {
      // change no estaba
      fontSize: '1rem',
    },
    body2: {
      // change no estaba
      fontSize: '0.875rem',
    },
  },
  /* typography: {
    button: {
      fontWeight: 600
    },
    htmlFontSize: 16,
    pxToRem: f(),
    fontSize: 14,
    fontFamily: '"Robot", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '6rem' // change era '3.5rem'
    },
    h2: {
      fontWeight: 600,
      fontSize: '3.75rem' // change era '3rem'
    },
    h3: {
      fontWeight: 600,
      fontSize: '3rem' // change era '2.25rem'
    },
    h4: {
      fontWeight: 600,
      fontSize: '2.125rem' // change era '2rem'
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem' // change era '1.5rem'
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem' // change era '1.125rem'
    },
    overline: {
      fontWeight: 600
    },
    caption: {
      fontSize: '0.9rem' // change era '0.9rem'
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '1rem' // change no estaba
    },
    subtitle2: {
      fontSize: '0.875rem' // change era '0.9rem'
    },
    body1: { // change no estaba
      fontSize: '1rem'
    },
    body2: { // change no estaba
      fontSize: '0.875rem'
    }
  } */
};

const themesOptions = {
  [THEMES.CLARO]: {
    components: {
      MuiInputBase: { styleOverrides: { input: { '&::placeholder': { opacity: 0.86, color: '#42526e' } } } },
    },
    palette: {
      backgroundTextFieldDisabled: { default: '#f0f0f0' },
      backgroundRow: { main: '#bbdefb', error: '#ffcdd2', warning: '#fdecce' },
      backgroundGoals: { low: '#ef5350', medium: '#ffee58', high: '#81c784', contrastText: '#172b4d' },
      girosWarning: { main: '#fac574', hover: '#e08d08', contrastText: '#172b4d' },
      action: { active: '#6b778c' },
      background: { default: '#f4f5f7', paper: '#ffffff', tab: '#e5eaf1ff' },
      divider: '#e9e9e9ff',
      dividerEnfasis: '#5e6b77',
      error: { contrastText: '#ffffff', main: '#d32f2f' },
      mode: 'light',
      primary: {
        contrastText: '#ffffff',
        main: '#3f51b5', // era '#5664d2' change
      },
      primary2: { contrastText: '#ffffff', main: '#3f51b5' },
      success: { contrastText: '#ffffff', main: '#4caf50' },
      success2: { contrastText: '#ffffff', main: '#23a327' },
      text: { primary: '#172b4d', secondary: '#6b778c' },
      warning: { contrastText: '#ffffff', main: '#D97706' },
      warningLight: { contrastText: '#846900', main: '#f2be00' },
      danger: { contrastText: '#ffffff', main: '#f50057' },
      info: { contrastText: '#ffffff', main: '#0288d1' },
      info2: { contrastText: '#172b4d', main: '#e3f2fd' },
      secondary: {
        // afecta select en react-table-core
        main: '#616161',
      },
    },
    shadows: lightShadows,
  },
  [THEMES.OSCURO]: {
    components: {
      MuiTableCell: { styleOverrides: { root: { borderBottom: '1px solid rgba(145, 158, 171, 0.24)' } } },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: '#CCCCCC', // Match your text primary color
            '&:hover': {
              backgroundColor: 'rgba(204, 204, 204, 0.08)', // Slight highlight on hover
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: '#4493ee', // Primary2 main color
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: '#4493ee', // Primary2 main color
            },
          },
        },
      },
      MuiInputLabel: { styleOverrides: { root: { '&.Mui-focused': { color: '#4493ee' } } } },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#4493ee' } },
            input: { '&:-webkit-autofill': { WebkitBoxShadow: `0 0 0 100px #1c3653 inset` } },
          },
        },
      },
      MuiCheckbox: { styleOverrides: { root: { '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#4493ee' } } } },
      MuiListSubheader: {
        styleOverrides: { root: { '&.Mui-selected': { color: '#4493ee', backgroundColor: '#1c3653' } } },
      },
      MuiOutlinedInput: {
        styleOverrides: { root: { '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4493ee' } } },
      },
      MuiCssBaseline: {
        styleOverrides: {
          'body a': {
            color: '#4493ee',
            textDecoration: 'underline',
            textDecorationColor: '#4493ee80',
            transition: 'text-decoration-color 0.2s ease-in-out',
            '&:hover': { textDecoration: 'underline' },
          },
        },
      },
      MuiLink: {
        // Para Links que salgan de este patron, modificar el color inline DENTRO del sx
        styleOverrides: {
          root: {
            color: '#4493ee',
            '.MuiBreadcrumbs-root &': {
              color: '#CCCCCC',
              textDecoration: 'underline',
              textDecorationColor: '#cccccc80',
              transition: 'text-decoration-color 0.2s ease-in-out',
              '&:hover': { textDecoration: 'underline' },
            },
            textDecoration: 'underline',
            textDecorationColor: '#4493ee80',
            transition: 'text-decoration-color 0.2s ease-in-out',
            '&:hover': { textDecoration: 'underline' },
          },
        },
      },
      MuiRadio: { styleOverrides: { root: { [`&.${radioClasses.checked}`]: { color: '#4493ee' } } } },
    },
    palette: {
      backgroundTextFieldDisabled: { default: '#2a3341' },
      backgroundRow: { main: ' #1c3653', error: 'rgb(85, 31, 51)', warning: '#3d2e1aff' },
      backgroundGoals: { low: '#cc3b3b', medium: '#dbbb39', high: '#5ea661', contrastText: '#ffffff' },
      girosWarning: { main: '#794811', hover: '#523208', contrastText: '#172b4d' },
      action: { active: '#65686d' },
      background: { default: '#181d25', paper: '#222b36', tab: '#1d2531' },
      divider: 'rgba(145, 158, 171, 0.24)',
      dividerEnfasis: '#a0a0a0',
      error: { contrastText: '#ffffff', main: '#c64949' },
      mode: 'dark',
      primary2: {
        // Para Typography, se debe escribir DENTRO del sx, color: theme.palette.primary2.main
        contrastText: '#ffffff',
        main: '#4493ee',
      },
      primary: { contrastText: '#fcfcfc', main: '#3b47b3' },
      success: { contrastText: '#ffffff', main: '#4b934d' },
      success2: { contrastText: '#ffffff', main: '#50a354' },
      text: { primary: '#CCCCCC', secondary: '#919eab' },
      warning: { contrastText: '#f5f5f5', main: '#cc791b' },
      warningLight: { contrastText: '#846900', main: '#c9a52a' },
      danger: { contrastText: '#f0eded', main: '#b23a3a' },
      info: { contrastText: '#eeeeee', main: '#1c87b1ff' },
      info2: { contrastText: '#f1f1f1', main: '#313942' },
      secondary: {
        // afecta select en react-table-core
        main: '#495565',
      },
    },
    shadows: darkShadows,
  },
};

export const createCustomTheme = (config = {}) => {
  let themeOptions = themesOptions[config.theme];

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    themeOptions = themesOptions[THEMES.CLARO];
  }

  let theme = createTheme(
    merge({}, baseOptions, themeOptions, { ...(config.roundedCorners && { shape: { borderRadius: 16 } }) })
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
